(ns manage.content-variant-page.macro.db
  (:require [common.ui.store :as store]
            [re-frame.core :as rf]
            [re-posh.core :as rp]))

;; Keep full parameter names for record dummy impl
#_{:clj-kondo/ignore [:unused-binding]}

(defrecord MacroGroup [macro-key macros]
  store/DataDomainEntity
  (identifier [_] macro-key)

  ;; Dummy implementation, just good enough to avoid crashes
  (entity [this] (store/entity this nil))
  (entity [_ selection] (atom nil))
  (set-value! [this k v] nil)
  (unset-value! [_ k] nil)
  (get-value [this k] (atom nil)))

(defn macros [macro-group]
  (map :db/id (:macros macro-group)))

(defn some-macro-eid [macro-group]
  (first (macros macro-group)))

(rp/reg-sub :macro-group/mapped-placeholder
  (fn [_ [_ macro-group]]
    {:type :query
     :query '[:find ?p . :in $ ?m
              :where
              [?r :rule/condition ?m]
              [?tv :mapped-targeting-value/rule ?r]
              [?tk :targeting-key/targeting-value ?tv]
              [?tk :targeting-key/placeholder ?p]]
     :variables [(some-macro-eid macro-group)]}))

(rp/reg-sub :macro-group/dynamic-placeholder-override
  (fn [_ [_ macro-group]]
    {:type :query
     :query '[:find ?phe . :in $ ?m :where [?phe :singular-placeholder-expression/macro ?m]]
     :variables [(some-macro-eid macro-group)]}))

(rf/reg-event-fx :macro/delete-group
  [(rf/inject-cofx :sub (fn [[_ macro-group]] [:macro-group/mapped-placeholder macro-group]))
   (rf/inject-cofx :sub (fn [[_ macro-group]] [:macro-group/dynamic-placeholder-override macro-group]))]
  (fn [{:macro-group/keys [mapped-placeholder dynamic-placeholder-override]} [_ macro-group]]
    {:fx [[:dispatch
           (cond (some? mapped-placeholder) [:modal/open {:id :macro/confirm-delete :props {:macro-group macro-group}}]
                 (some? dynamic-placeholder-override) [:ui.store/delete dynamic-placeholder-override])]]}))

(rf/reg-event-fx :macro/delete-group-mapped  ; executed after the user confirmed deletion
  [(rf/inject-cofx :sub (fn [[_ macro-group]] [:macro-group/mapped-placeholder macro-group]))]
  (fn [{:macro-group/keys [mapped-placeholder]} [_ macro-group]]
    {:fx [[:dispatch [:ui.store/delete (macros macro-group)]]
          (when @(rf/subscribe [:placeholder/allow-toggle-dynamic<->mapped? mapped-placeholder]) ; ugh, sub in handler
            [:dispatch [:placeholder/->dynamic mapped-placeholder]])]}))
